<template>
<div id="catalogo_mt">
  <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
  components: {
    "v-power-catalogo": powerCatalogo
  },
  created() {
    window.getApp.$emit("APP_DRAWER_HIDE");
  },

  data: () => ({
    fab: false,
    parametros: {
      url_actions: "apendices/",
      url_list: "apendices/lista/",
      tabla: 31,
      title: "TIPO DE INFORMES",
      columns: ["clave", "nombre", "actions"],
      options: {
        filterable: ["clave", "nombre"],
        sortable: ["clave", "nombre"],

        headings: {
          clave: "Clave",
          nombre: "Nombre",
          actions: "Operaciones"
        }
      },
      camposexcel: {
        Clave: "clave",
        Nombre: "nombre",
      },
      encabezadoLayout: {
        clave: "clave",
        nombre: "nombre",
      },
      camposLayout: [{
        clave: "[Clave del Destino Aduanero]",
        nombre: "[Nombre del Destino Aduanero]",
      }],
      model: {
        id: 0,
        clave: "",
        nombre: "",
      },
      form: {
        clave: {
          requiered: true,
          label: "Clave",
          value: "",
          maxlen: 50
        },
        nombre: {
          requiered: true,
          label: "Nombre",
          value: "",
          maxlen: 350
        }
      },
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "Utilerías",
          disabled: true,
          to: ""
        },
        {
          text: "Apendices",
          disabled: true,
          to: ""
        }
      ]
    }
  })
};
</script>
<style scoped>
.v-card--material {
  min-height: 750px !important;
}
</style>
<style scoped>
.VueTables>>>thead th {
  white-space: normal !important;
}

.VueTables>>>tbody td {
  white-space: normal !important;
}
</style>
